// extracted by mini-css-extract-plugin
export var blink = "_ah-2";
export var cursor = "_ah-1";
export var reactMarkdown = "_ah-3";
export var streamingText = "_ah-0";